import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ProgressDashboard from '../../progress/ProgressDashboard';

/**
 * ProgressDialog Component
 * Modal wrapper for the ProgressDashboard to be used in the dashboard
 */
const ProgressDialog = ({ open, onClose, token }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        pb: 1
      }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          My Progress Dashboard
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {open && <ProgressDashboard token={token} />}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ borderRadius: '12px' }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProgressDialog;